import { EventRequestById } from "../../models/event";

export const mockedWorkordersGetEventsById: EventRequestById[] = [
  {
    id: 6914591,
    requestId: 1,
    type: "R",
    statusCode: "E",
    statusName: "",
    statusDate: new Date("2021-08-05T21:05:30.000Z"),
    creationDate: new Date("2021-08-05T21:05:30.000Z"),
    reason: "",
    internalComment:
      "Ancien responsable : PARENT, ISABELLE (GROUPE VOIRIE OPERATIONS SUD OUEST), DIVISION DE LA VOIRIE, ANJOU , Nouveau responsable : GROUPE VOIRIE OPERATIONS SUD OUEST, DIVISION DE LA VOIRIE, ANJOU",
    user: "UPAREZF",
    userFirstName: "ISABELLE",
    userLastName: "PARENT",
  },
  {
    requestId: 1,
    statusCode: "",
    statusName: "",
    reason: "",
    creationDate: new Date("2021-10-08T14:51:24.000Z"),
    id: 6917234,
    internalComment: "test",
    statusDate: new Date("2021-10-08T14:51:24.000Z"),
    type: "C",
    user: "CGSNCM1",
    userFirstName: "TestMobile",
    userLastName: "Test",
  },
  {
    requestId: 1,
    statusCode: "",
    statusName: "",
    reason: "",
    creationDate: new Date("2021-10-08T15:54:20.000Z"),
    id: 6917235,
    internalComment: "fdfsd",
    statusDate: new Date("2021-10-08T15:54:20.000Z"),
    type: "C",
    user: "CGSNCM1",
    userFirstName: "TestMobile",
    userLastName: "Test",
  },
  {
    requestId: 1,
    statusCode: "",
    statusName: "",
    reason: "",
    creationDate: new Date("2020-10-05T14:22:40.000Z"),
    id: 6914591,
    internalComment:
      "Ancien responsable : PARENT, ISABELLE (GROUPE VOIRIE OPERATIONS SUD OUEST), DIVISION DE LA VOIRIE, ANJOU , Nouveau responsable : GROUPE VOIRIE OPERATIONS SUD OUEST, DIVISION DE LA VOIRIE, ANJOU",
    statusDate: new Date("2020-10-05T14:22:40.000Z"),
    type: "R",
    user: "UPAREZF",
    userFirstName: "ISABELLE",
    userLastName: "PARENT",
  },
  {
    requestId: 1,
    statusCode: "",
    statusName: "",
    reason: "",
    creationDate: new Date("2020-10-05T14:31:14.000Z"),
    id: 6914597,
    statusDate: new Date("2020-10-05T14:31:14.000Z"),
    type: "R",
    user: "UPAREZF",
    userFirstName: "ISABELLE",
    userLastName: "PARENT",
  },
  {
    requestId: 1,
    statusCode: "",
    statusName: "",
    reason: "",
    creationDate: new Date("2020-10-05T14:22:41.000Z"),
    id: 6914593,
    internalComment:
      "Ancien responsable : GROUPE VOIRIE OPERATIONS SUD OUEST, DIVISION DE LA VOIRIE, ANJOU , Nouveau responsable : PARENT, ISABELLE ( GROUPE VOIRIE OPERATIONS SUD OUEST), ANJOU, ANJOU",
    statusDate: new Date("2020-10-05T14:22:41.000Z"),
    type: "R",
    user: "UPAREZF",
    userFirstName: "ISABELLE",
    userLastName: "PARENT",
  },
  {
    requestId: 1,
    statusName: "",
    reason: "",
    creationDate: new Date("2020-10-05T14:22:41.000Z"),
    id: 6914592,
    statusCode: "P",
    statusDate: new Date("2020-10-05T14:22:39.000Z"),
    type: "S",
    user: "UPAREZF",
    userFirstName: "ISABELLE",
    userLastName: "PARENT",
  },
  {
    id: 6914591,
    requestId: 2,
    type: "R",
    statusCode: "E",
    statusName: "",
    statusDate: new Date("2021-08-05T21:05:30.000Z"),
    creationDate: new Date("2021-08-05T21:05:30.000Z"),
    reason: "",
    internalComment:
      "Ancien responsable : PARENT, ISABELLE (GROUPE VOIRIE OPERATIONS SUD OUEST), DIVISION DE LA VOIRIE, ANJOU , Nouveau responsable : GROUPE VOIRIE OPERATIONS SUD OUEST, DIVISION DE LA VOIRIE, ANJOU",
    user: "UPAREZF",
    userFirstName: "ISABELLE",
    userLastName: "PARENT",
  },
];
